<template>
  <div
    class="storenotecardstyle style"
    :class="{ 'float-active': isAnimate }"
    style="border: 1px solid blue"
  >
    <!-- 表单 -->
    <el-form
      label-width="90px"
      :model="datas"
      size="small"
      class="lef"
      style="margin-top: 20px"
    >
      <el-form-item label="模块名称：">
        <div class="weiz">
          <div class="ml35">
            <el-input disabled v-model="datas.moduleName"> </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="checkbox-row" label="选择文章：">
        <div class="weiz">
          <div class="ml35">
            <el-radio-group v-model="active" @change="handleActiveChange">
              <el-radio :label="1">直接添加</el-radio>
              <el-radio :label="2">使用筛选条件</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div v-if="active == 1">
          <CustomTransfer
            ref="CustomTransfer"
            :options="datas.articleList"
            v-model="datas.checkedArticleList"
            @add-article="prependArticle"
            @input="handleDirectAdd"
            @handleRemove="handleRemove"
          />
        </div>
        <div v-else>
          <div>
            <SelectArticle
              ref="selectArticle"
              :options="datas.CategoryArticleList"
              v-model="datas.checkedCategoryList"
              @change="handleRow1Change"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item class="form-title" label="文章标题："> </el-form-item>
      <el-form-item
        label="字体："
        prop="fontWeight"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.fontFamily" placeholder="请选择字体">
              <el-option
                v-for="item in fontFamilyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 标题大小 -->
      <el-form-item
        label="字号："
        prop="wordSize"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.fontSize" placeholder="请选择字号">
              <el-option
                v-for="item in wordSizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 文字颜色 -->
      <el-form-item class="lef" label="颜色：">
        <div class="weiz">
          <!-- 1. 修改文字显示逻辑，新增居右判断 -->
          <div style="margin-left: 35px">
            <el-color-picker
              v-model="datas.textColor"
              show-alpha
              @change="handleCustomColorChange($event, 'textColor')"
            ></el-color-picker>
          </div>
          <div>
            <el-input placeholder="请输入文字颜色" v-model="datas.textColor">
            </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="form-title" label="文章内容："> </el-form-item>
      <el-form-item
        label="字体："
        prop="fontWeight"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.subFontFamily" placeholder="请选择字体">
              <el-option
                v-for="item in fontFamilyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 标题大小 -->
      <el-form-item
        label="字号："
        prop="wordSize"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.subFontSize" placeholder="请选择字号">
              <el-option
                v-for="item in wordSizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 文字颜色 -->
      <el-form-item class="lef" label="颜色：">
        <div class="weiz">
          <!-- 1. 修改文字显示逻辑，新增居右判断 -->
          <div style="margin-left: 35px">
            <el-color-picker
              v-model="datas.subTextColor"
              show-alpha
              @change="handleCustomColorChange($event, 'subTextColor')"
            ></el-color-picker>
          </div>
          <div>
            <el-input placeholder="请输入文字颜色" v-model="datas.subTextColor">
            </el-input>
          </div>
        </div>
      </el-form-item>

      <!-- 卡片样式选择 -->
      <el-form-item
        class="lef"
        label="模块样式："
        v-if="datas.checkedArticleList.length > 0"
      >
        <div class="weiz">
          <div class="weiz-container" style="">
            <!-- 模块样式 -->
            <div
              v-for="(item, index) in moduleStyleList"
              :key="index"
              @click="clickChange(item, index)"
              class="preview-item"
              :class="{ active: moduleType == item.commodityType }"
            >
              <RightPanelModuleStyle
                :datas="item"
                :imagePath="item.src"
              ></RightPanelModuleStyle>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  wordSizeOptions,
  fontFamilyOptions,
  predefineColors,
  searchOptions,
} from "@/utils/defaultData.js";
export default {
  name: "storenotecardstyle",
  props: {
    datas: Object,
  },
  data() {
    let kon = (rule, value, callback) => {
      if (value.length === 0) callback(new Error("请输入有效数字"));
    };
    return {
      isAnimate: false, // 动画触发开关
      // 可选文章列表（对象数组，包含id、title等字段）
      rawArticleList: [
        {
          id: 211,
          text: "从用户的控制感角度，广告设计如何优化",
          description: "应该优化广告的头牌",
        },
        {
          id: 54,
          text: "外卖品牌设计一级案例解读",
          description: "外卖行业这些年的发展给餐饮行业带来了新的气象",
        },
      ],
      // 已选文章列表（对象数组，双向绑定）
      selectedArticles: [],
      active: 1, //选择文章默认选中项
      moduleType: 2, //默认选中的模块样式
      // 构造模块样式列表
      moduleStyleList: [
        { ...this.datas, src: this.$imagePath.image15, commodityType: 2 },
        {
          ...this.datas,
          src: this.$imagePath.image16,
          commodityType: 1,
        },
        {
          ...this.datas,
          src: this.$imagePath.image17,
          commodityType: 4,
        },
      ],
      optionsType1: [
        {
          type: "10",
          name: "内部链接",
        },
        {
          type: "11",
          name: "外部链接",
        },
      ], // 选择跳转类型
      options1: [],
      moditystyles: [
        /* 卡片样式 */
        {
          text: "无边白底",
          type: 0,
        },
        {
          text: "卡片投影",
          type: 1,
        },
        {
          text: "描边白底",
          type: 2,
        },
        {
          text: "无边透明底",
          type: 3,
        },
      ],
      commodityTypes: [
        {
          icon: "icon-datumoshi",
          type: 0,
          content: "大图模式",
        },
        {
          icon: "icon-commodity-yihangliangge",
          type: 1,
          content: "一行两个",
        },
        {
          icon: "icon-xuanzemokuai-daohanghengxianghuadong",
          type: 2,
          content: "横向滑动",
        },
        {
          icon: "icon-sanlan",
          type: 3,
          content: "一大两小",
        },
        {
          icon: "icon-commodity-xiangxiliebiao",
          type: 4,
          content: "详细列表",
        },
      ],
      rules: {
        textWeight: [{ required: true, validator: kon, trigger: "blur" }],
      },
      marker: ["新品", "热卖", "NEW", "HOT"],
      dragOptions: {
        animation: 200,
      },
      optionsType: [
        {
          type: "10",
          name: "内部链接",
        },
        {
          type: "11",
          name: "外部链接",
        },
      ], // 选择跳转类型
      options: [], //后端返回的列表提供下拉选择
      emptyText: "",
    };
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    styleText() {
      if (this.datas.commodityType === 0) return "大图模式";
      if (this.datas.commodityType === 1) return "一行两个";
      if (this.datas.commodityType === 2) return "横向滑动";
      if (this.datas.commodityType === 3) return "详细列表";
      if (this.datas.commodityType === 4) return "一大两小";
      if (this.datas.commodityType === 5) return "横向滑动";
    },
    // 让父组件也能直接 push 新文章，同时保持响应式
    // articleList: {
    //   get() {
    //     return this.rawArticleList;
    //   },
    //   set(val) {
    //     this.rawArticleList = val;
    //   },
    // },
  },
  created() {
    console.log(
      "storenotecardstyle组件挂载模块样式",
      this.datas,
      this.moduleStyleList,
    );
    // 获取所有文章列表
    // this.getArticleList();
    // // 获取文章分类列表
    // this.getArticleCategory();
  },
  methods: {
    // 添加文章CustomTransfer弹窗
    CustomTransfer() {
      this.$refs.CustomTransfer.handleAddAll();
    },
    // 对外暴露的浮动方法（供父组件调用）动态上下浮动动画
    triggerFloat() {
      // 1. 先关闭动画（强制复位）
      this.isAnimate = false;
      // 2. 强制刷新DOM后开启动画（确保连续点击也能触发）
      this.$nextTick(() => {
        this.isAnimate = true;
        // 3. 动画结束后关闭开关（复位），时长和CSS动画一致
        setTimeout(() => {
          this.isAnimate = false;
        }, 600); // 对应CSS中动画时长0.6s
      });
    },
    // 直接添加/使用筛选条件
    handleActiveChange(event) {
      console.log(
        "直接添加/使用筛选条件回调事件切换-----------------",
        event,
        this.datas,
      );
      // 判断对应类型里是否已追加文章列表 对应回显之前的列表
      if (event == 1) {
        console.log("等于1了", event, this.datas);
        if (this.$refs.CustomTransfer.selectedList.length == 0) {
          this.datas.imageList = [];
          return;
        }
        const newList = this.$utils.mergeWithDefaults(
          [],
          this.$refs.CustomTransfer.selectedList,
          {
            extraKeys: ["subTitle", "src"],
            srcValue: this.$imagePath.image7,
          },
        );
        this.datas.imageList = newList;
      } else {
        // 2. 调用后端接口根据分类id查询文章
        console.log("等于2了", event, this.datas);
        if (this.datas.checkedCategoryList.length == 0) {
          this.datas.imageList = [];

          return;
        }
        this.$api.admin.article
          .getArticleListByCategoryIdAPI({
            category_ids: this.datas.checkedCategoryList,
          })
          .then((res) => {
            // 2. 把新选文章转成完整字段
            const newList = this.$utils.mergeWithDefaults([], res.data.data, {
              extraKeys: ["subTitle", "src"],
              srcValue: this.$imagePath.image7,
            });
            this.datas.imageList = newList;
          });
      }
    },
    // 获取左侧文章列表数据
    async getArticleList() {
      const result = await this.$api.admin.article.getArticleListAPI();
      const list = result.data
        .map((item) => ({
          id: item.id,
          text: item.text,
          description: item.description,
        }))
        .reverse();
      // 关键：写进 datas，让 CustomTransfer 能读到
      this.$set(this.datas, "articleList", list);
      console.log("获取左侧文章列表结果---", this.datas.articleList);
    },
    // 获取所有文章分类列表数据
    async getArticleCategory() {
      const result = await this.$api.admin.article.getArticleCategoryAPI();
      this.datas.CategoryArticleList = result.data.data;
      console.log("获取文章分类列表结果---", result, this.datas);
    },
    // 子组件弹窗点“确定”后会把新文章 emit 出来
    async prependArticle(newArticle) {
      const result = await this.$store.dispatch(
        "modules/createArticle",
        newArticle,
      );
      // 重新获取左侧文章列表回显
      this.getArticleList();
      console.log(
        "最终父组件收到的新文章=======================",
        newArticle,
        result,
        this.datas,
      );
    },
    // 子组件左侧列表添加后回调函数
    handleDirectAdd(selectedArticles) {
      // 1. 旧数据兜底
      const oldList = this.datas.imageList || [];
      // 2. 把新选文章转成完整字段
      const newList = this.$utils.mergeWithDefaults(oldList, selectedArticles, {
        extraKeys: ["subTitle", "src"],
        srcValue: this.$imagePath.image7,
      });
      // 3. 合并并去重（以 id 为 key）
      const idSet = new Set(oldList.map((i) => i.id));
      const appendList = newList.filter((i) => !idSet.has(i.id));
      const finalList = [...oldList, ...appendList];
      console.log(
        "transfer子组件左侧列表添加后回调函数",
        selectedArticles,
        this.datas,
        finalList,
      );
       this.datas.imageList = finalList;
      return;
     
      // this.selectedArticles = selectedArticles;
    },
    // 从右侧移除指定文章
    handleRemove(item, index) {
      const findIndex = this.datas.imageList.findIndex((i) => i.id === item.id);
      if (findIndex === -1) {
        console.error("未找到要删除的文章");
        return;
      }
      this.datas.imageList.splice(findIndex, 1);
      console.log(
        "storenotecardstyle父组件穿梭框handleRemove回调点击删除按钮了",
        item,
        index,
        this.datas,
      );
    },
    // 处理文章选择变化
    handleRow1Change(val) {
      console.log(
        "处理文章选择变化回调------------------------------",
        val,
        this.datas,
      );
      // 2. 调用后端接口根据分类id查询文章
      this.$api.admin.article
        .getArticleListByCategoryIdAPI({ category_ids: val })
        .then((res) => {
          // 2. 把新选文章转成完整字段
          const newList = this.$utils.mergeWithDefaults([], res.data.data, {
            extraKeys: ["subTitle", "src"],
            srcValue: this.$imagePath.image7,
          });
          // 3. 合并并去重（以 id 为 key）
          // const idSet = new Set(oldList.map((i) => i.id));
          // const appendList = newList.filter((i) => !idSet.has(i.id));
          // const finalList = [...oldList, ...appendList];
          this.datas.imageList = newList;
          // 对象数组去重
          // this.datas.imageList = this.$utils.uniqueObjectArray(
          //   res.data.data,
          //   "categoryId",
          // );
          console.log(
            "根据分类id查询文章结果",
            res,
            this.datas.imageList,
            newList,
          );
        });
    },
    // 处理文字颜色选择器变化
    handleCustomColorChange(color, type) {
      this.datas[type] = color;
      console.log("文字颜色选择事件", color, type, this.datas);
    },
    //模块样式选择回调
    clickChange(item, index) {
      this.moduleType = item.commodityType;
      this.datas.commodityType = item.commodityType;
      console.log("模块样式点击了", item, index, this.datas);
    },
    selectType(index) {
      // 每次切换类型之前 清空之前选中跳转
      this.datas.imageList[index].http = {};
      // 清空 options
      this.options = [];
    },
    // 提交
    uploadInformation(res) {
      this.datas.imageList.push({
        src: res,
        text: "这里显示笔记标题最多显示2行",
        http: {},
        type: "1",
      });
    },

    /* 删除图片 */
    deleteimg(index) {
      this.datas.imageList.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
/* 浮动激活状态：上下移动 */
.storenotecardstyle.float-active {
  /* 先向下移动10px，再向上移动10px（通过关键帧更灵活，这里用过渡模拟） */
  animation: floatAnimation 0.6s ease-in-out forwards;
}
/* 定义上下浮动的关键帧 */
@keyframes floatAnimation {
  0% {
    transform: translateY(0);
  } /* 初始位置 */
  30% {
    transform: translateY(15px);
  } /* 向下浮动 */
  60% {
    transform: translateY(-15px);
  } /* 向上浮动 */
  100% {
    transform: translateY(0);
  } /* 回到原始位置 */
}
.storenotecardstyle {
  width: 100%;
  left: 0;
  top: 0;
  padding: 0 10px 20px;
  box-sizing: border-box;
  /* 过渡效果：指定要动画的属性 + 时长 + 缓动函数 */
  transition: transform 0.8s ease-in-out;
  /* 初始位置 */
  transform: translateY(0);

  /* 标题 */
  h2 {
    padding: 24px 16px 24px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #f2f4f6;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
  }

  .lef {
    ::v-deep.el-form-item__label {
      text-align: left;
    }
  }

  /* 图片字 */
  .imgText1 {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    .fir-sele.el-select {
      width: 40%;
    }
  }

  /* 列表样式 */
  .commodityType {
    display: flex;
    justify-content: space-around;
    align-items: center;
    span {
      display: inline-block;
      width: 58px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      background: #fff;
      border: 1px solid #ebedf0;
      color: #979797;
      margin: 0 1px;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        border: 1px solid #155bd4;
        color: #155bd4;
      }

      &.active {
        border: 1px solid #155bd4;
        background-color: #e0edff;
        color: #155bd4;
      }
    }
  }

  /* 卡片样式 */
  .moditystyle {
    font-size: 12px;
    width: 100%;
    display: flex;
    span {
      width: 86px;
      height: 32px;
      display: inline-block;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
      border: 1px solid #ebedf0;
      &.active {
        border: 1px solid #155bd4;
        background-color: #e0edff;
        color: #155bd4;
      }
    }
  }

  /* 位置 */
  .weiz {
    text-align: right;
    i {
      padding: 5px 14px;
      margin-left: 10px;
      border-radius: 0;
      border: 1px solid #ebedf0;
      font-size: 20px;
      font-weight: 500;
      cursor: pointer;

      &:last-child {
        font-size: 22px;
      }

      &.active {
        color: #155bd4;
        border: 1px solid #155bd4;
        background: #e0edff;
      }
    }
  }

  /* 单选框 */
  ::v-deep.radi1 {
    border-top: 1px solid #f7f8fa;
    border-bottom: 1px solid #f7f8fa;
    padding: 12px 0;
    .el-radio {
      margin: 10px 25px 7px 0;
    }
  }

  /* 卡片列表 */
  .imgBanner {
    padding: 6px 12px;
    margin: 16px 7px;
    border-radius: 2px;
    background-color: #fff;
    box-shadow: 0 0 4px 0 rgba(10, 42, 97, 0.2);
    display: flex;
    position: relative;

    /* 删除图标 */
    .el-icon-circle-close {
      position: absolute;
      right: -10px;
      top: -10px;
      cursor: pointer;
      font-size: 19px;
    }

    /* 图片 */
    .imag {
      width: 60px;
      height: 60px;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: inline-block;
      }
      span {
        background: rgba(0, 0, 0, 0.5);
        font-size: 12px;
        position: absolute;
        left: 0px;
        bottom: 0px;
        display: inline-block;
        width: 100%;
        text-align: center;
        color: #fff;
        height: 20px;
        line-height: 20px;
      }
    }

    /* 图片字 */
    .imgText {
      width: 80%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding-left: 20px;
      justify-content: space-between;
      /* 图片字 */
      .imgTextChild {
        width: 100%;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        .fir-sele.el-select {
          width: 40%;
        }
      }
    }
  }

  /* 上传图片按钮 */
  .uploadImg {
    width: 345px;
    height: 40px;
    margin-top: 20px;
  }

  // 上传弹框内容部分
  ::v-deep.uploadIMG .el-dialog__body {
    height: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;
  }

  .disable {
    ::v-deep.el-upload {
      display: none !important;
    }
  }

  .tit {
    ::v-deep.el-input__inner {
      text-align: center;
    }
  }
}
</style>
